// Costanti e helper del modulo Coda Lavori / Lead (mirror backend).
export const ASSIGNMENT_STATES = [
  "Da prendere in carico", "Preso in carico", "Appuntamento fissato",
  "In lavorazione", "Chiuso", "Chiuso - Vinto", "Chiuso - Perso",
  "Non interessato", "Annullato",
];
export const ASSIGNMENT_OPEN = [
  "Da prendere in carico", "Preso in carico", "Appuntamento fissato", "In lavorazione",
];
export const OFFICE_NAMES = ["Mirandola", "Carpi", "Nonantola", "San Giovanni in Persiceto"];
export const OPP_TYPES = [
  "Fotovoltaico", "Sistema di accumulo", "Climatizzazione", "Pompa di calore",
  "Caldaia", "Wallbox", "Commodity", "Luce", "Gas", "Altro",
];
export const ASSIGNMENT_PRIORITIES = ["Bassa", "Media", "Alta", "Urgente"];
export const CUSTOMER_TYPES = ["Privato", "Azienda", "Condominio"];

// StatusBadge tone: colore + testo + icona (mai solo colore).
export function assignmentTone(s) {
  if (s === "Chiuso" || s === "Chiuso - Vinto") return "success";
  if (s === "Non interessato" || s === "Annullato" || s === "Chiuso - Perso") return "danger";
  if (s === "Da prendere in carico") return "warning";
  if (s === "Appuntamento fissato") return "info";
  return "pending"; // Preso in carico / In lavorazione
}

export function priorityTone(p) {
  if (p === "Urgente") return "danger";
  if (p === "Alta") return "warning";
  if (p === "Media") return "info";
  return "pending"; // Bassa / altro
}

export function kindLabel(k) {
  return k === "lead_sede" ? "Lead da sede" : "Lavoro Direzione";
}

export function workLabel(a) {
  return a?.display_label || a?.customer_name || a?.contact_name || a?.title || "Lavoro libero";
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function fmtSize(bytes) {
  if (bytes == null) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
